import { HomeIcon } from "@heroicons/react/outline";
import { publicRoute } from "routing";
import type { RouteType } from "core/helpers/navigation";
import { BaseLayout } from "components/ux/layouts/BaseLayout";
import { HomeScreen } from "screens/public/home";
import { AccessibilityStatementScreen } from "screens/public/accessibilityStatement";

export const routeList: Array<RouteType> = [
  //    Public routes
  {
    path: publicRoute.home,
    menuName: "Accueil",
    element: (
      <BaseLayout>
        <HomeScreen />
      </BaseLayout>
    ),
    menuVisibility: "always",
    menuIcon: HomeIcon,
    auth: false,
  },
  {
    path: publicRoute.accessibility,
    menuName: "Accessibilite",
    element: (
      <BaseLayout>
        <AccessibilityStatementScreen />
      </BaseLayout>
    ),
    menuVisibility: "never",
    auth: false,
  },
];
export const authFallBack = publicRoute.home;
